import { useAppSelector } from '~/app/hooks'
import { isDarkTheme } from '~/redux/features'

export function AssetsIcon() {
  const isDark = useAppSelector(isDarkTheme)
  const idSuffix = Math.random().toString().replace('.','');
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <mask
        id={`mask0_11_11272${idSuffix}`}
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='24'
      >
        <rect
          width='24'
          height='24'
          fill={`url(#pattern${idSuffix})`}
        />
      </mask>
      <g mask={`url(#mask0_11_11272${idSuffix})`}>
        <rect
          x='0'
          y='0'
          width='24'
          height='24'
          fill={isDark ? 'var(--color-dark-theme)' : 'var(--icon-color-light-theme)'}
        />
      </g>
      <defs>
        <pattern
          id={`pattern${idSuffix}`}
          patternContentUnits='objectBoundingBox'
          width='1'
          height='1'
        >
          <use
            xlinkHref='#image0_12146_18018'
            transform='scale(0.02)'
          />
        </pattern>
        <image
          id='image0_12146_18018'
          width='50'
          height='50'
          xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAAEdElEQVRogd3aaaiUVRgH8J9eFRe6LqlZgblkQoslSH0qhEorW4wI/JJBlFJ9abEP7UFFQUTQAhEUhBARZkmK7QtamBVEi5llXTXb1IzSSkunD88Z32mcfe7cGfvDYe455z3P/P/vOc9znnPuUB5T8AjWYye+xn04rMKYjkIX7sZe5EqULzGpbexqxDAsE4T34SmcikE4AR+kvo04uk0cq2IY3hdEt+GMor5R6JaJ+Ryj+5hjVfTH84LgBkwu6BuJj7Ak1UcLETl8KMR1DG4VxHbg2IL2kYJsDyYIgUelsjGNWSZeRNtxDP7EfswqaB8hllEPJmK6EHpv6p8iolkOd/YV2Uq4X5B5tqBtBNZik4hQp2A7XsZgnIfxOF8EhX2Y03eUS+NjIeT0VM+L2CxEnCxEvCJELBCzd2l6/o40fos27zG/JiKDMARrhIjJQsQ2vJr6rhQibi4Y3yX8KIeH+ox1CXybSEzAWCwXDj9NiHhNiLhCLKFbStiYgX/wtwgEbcGjQshLGJDaJuJnvC5EXC5E3FbBzpJkp9IzLcU4/JhIvCD8YLxYJkNxmXjbt1exMzvZWNsypjVghlhGObwhc9qzhIji8Dpb+NFWWbQaLtuLmsFMPImvxLawUySuS7EQY6oZOB7fyd7qWBG15pd4drMsidyU2rpT/fsGBUzFm0onqoXld7GXDa5kbIJ4E/lwelqZ5zYVGP4mtV2d6ssbEDEfu9P47SKkn5jIduM44acviqiZE9H1yEpGj8Cq9PBfuAb9ip6ZJXb8nvT3NPGmcji3DgFdeED2Up4W+1glTBdHiZzIASvOzEA8XPAFb4mlVwrTZEtycU30A91i9nLi7LOwjrEj8UUa+2AtA+aJMJz/smdwZiIxHNdil0zwerE8q2ESPpMdGWbWISKPk0Qg+kOsoqoYhcfFPlLOARfLUp0fcE4Fe5fIIuQnmjttPpfs3FDPoPG4S6Qjv4jotFxGultsoDnhkEtxtji/jMHFBf35PavZ3GxesrWiSTsHoQuLxHSXm70duMrBAaQRTEw2e3rBVkmME5voGkH8J7yNG/XuiXKoELK7F222BYcLIbs64ojaBKamz62HupAL0ud7bWXRJIbIsvZ6somOwz1CxDoFtzgDRdhcp/xVaTvLHnyK68Thb0Zq2y+OGgdErOwAsrWWlbJjxGOFU3STLLW4SMTmTsNQzJX5RA7vCj85gHWp48K+ZtcA5gquvylx75z3iU6ciWLkd/I9pTrzU1WMd8SVaaN1aju6ViqrauXbr6CxOIkrbq+3XtjWDKrxQnaP1Wo0kunW9RIO9RTlAPpqRnpjiVVEq2dkdZPjSzl7WZSLWsXt9dZbhZLf87/xkVYLmSPuvLaoPdVuZAxau7S2FLRvrpFPtTH/76VVKfyu9l/l9daJ/zc+kdoX1MipkTE4NJPGvcUd/cWvfohbwU7H7PS5oVTnItnBaq743UmnYZi4cs0frEre9Q4Qd6ftPsLWWlao4NsDcL246t/TAWSLS/Hlw0H4FxvOEy4IZJH2AAAAAElFTkSuQmCC'
        />
      </defs>
    </svg>
  )
}
